import './App.css';
import Weather from './components/Weather'
import NavBar from './components/NavBar'
import Footer from './components/Footer'

function App() {
  return (
    <>
      <NavBar/>
      <Weather/>
      <Footer/>
    </>
  );
}

export default App;
